import React from 'react';
import { useRouter } from 'next/router';
// Hooks
import { useGetCurrUser } from 'hooks';
// Components
import Divider from 'ui/Divider/Divider';
// Ui2
import Button from 'ui2/Button/Button';
import LinkButton from 'ui2/LinkButton/LinkButton';

import styles from './CTA.module.scss';

export const CTA: React.FC = () => {
  const router = useRouter();
  const { data } = useGetCurrUser();

  const isButtonsDisabled = !!data?.me;

  const handleSignInClick = () => {
    router.push({
      query: 'signIn=true',
    });
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h3 className={styles.title}>JOIN US ON MILLIONS</h3>
        <Divider className={styles.divider} />
        <ul className={styles.list}>
          <li className={styles.listItem}>
            <h4 className={styles.optionTitle}>CUSTOMER</h4>
            <p className={styles.optionDescription}>
              Get the coolest merch, and connect with your favorite athletes
              through Personal Videos and/or Stream.
            </p>
            <Button
              className={styles.optionLink}
              color="harvest-gold"
              onClick={handleSignInClick}
              disabled={isButtonsDisabled}
            >
              SIGN IN
            </Button>
          </li>

          <li className={styles.listItem}>
            <h4 className={styles.optionTitle}>ATHLETE</h4>
            <p className={styles.optionDescription}>
              We’ll work for you 24/7 to bring you the products you need to
              engage and grow your audience and revenue.
            </p>
            <Button
              className={styles.optionLink}
              color="harvest-gold"
              onClick={handleSignInClick}
              disabled={isButtonsDisabled}
            >
              SIGN IN
            </Button>
          </li>

          <li className={styles.listItem}>
            <h4 className={styles.optionTitle}>JOIN THE TEAM</h4>
            <p className={styles.optionDescription}>
              As Team Member / Ambassador / Investor, help grow and build a
              category defining company in sports, technology and beyond.
            </p>
            <LinkButton
              href="mailto:info@millions.co"
              className={styles.optionLink}
              color="harvest-gold"
            >
              GET IN TOUCH
            </LinkButton>
          </li>
        </ul>
      </div>
    </section>
  );
};
